import Button from '../common/Button';

function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div
        className="hero__image"
        style={{ '--hero-image': `url(${process.env.PUBLIC_URL}/images/landing-hero.png)` }}
        aria-label="Hydraulic cylinder repair image"
      >
        <div className="hero__overlay">
          <div className="container hero__inner">
            <h1 id="hero-title">Industrial Gearbox & Hydraulic Repair</h1>
            <p>Repair support for industrial gearboxes and hydraulic systems across Canada.</p>
            <div className="hero__actions">
              <Button href="tel:+14374357083" variant="outline-light">
                Call (437) 435-7083
              </Button>
              <Button to="/contact" variant="outline-light">
                Request a Quote
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
